// vendored from aiur 0f692a45b04bb4ce3e7d8256e134028894bd128b; do not edit
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */
export const CLIENT_FRAME_TYPES = ['start', 'audio', 'text', 'confirm_draft', 'discard_draft', 'end'];
export const SERVER_FRAME_TYPES = [
    'state',
    'transcript',
    'agent_text',
    'agent_audio',
    'interrupted',
    'draft',
    'delivery',
    'context_gap',
    'error',
    'ended',
];
const FRAME_TYPES = new Set([...CLIENT_FRAME_TYPES, ...SERVER_FRAME_TYPES]);
const MAX_FRAME_BYTES = 400_000;
const UTF8 = new TextEncoder();
export function encode(frame) {
    const encoded = JSON.stringify({ ...frame, v: 1 });
    if (UTF8.encode(encoded).byteLength > MAX_FRAME_BYTES) {
        throw new Error('frame_too_large');
    }
    return encoded;
}
export function decode(text) {
    if (UTF8.encode(text).byteLength > MAX_FRAME_BYTES) {
        throw new Error('frame_too_large');
    }
    let frame;
    try {
        frame = JSON.parse(text);
    }
    catch {
        throw new Error('invalid_frame');
    }
    if (!frame || typeof frame !== 'object')
        throw new Error('invalid_frame');
    const candidate = frame;
    if (candidate.v !== 1)
        throw new Error('unsupported_version');
    if (typeof candidate.type !== 'string' || !FRAME_TYPES.has(candidate.type)) {
        throw new Error('invalid_frame');
    }
    return candidate;
}
export function isServerFrame(frame) {
    return SERVER_FRAME_TYPES.includes(frame.type);
}
//# sourceMappingURL=wire.js.map